import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { UISocketService } from '../../../shared/services/ui.socket.service';
import { setSelectedSite } from '../actions/ui.actions';

@Injectable()
export class SiteDetailSocketsEffects {
    private readonly actions$ = inject(Actions);
    private readonly uISocketService = inject(UISocketService);

    subscribeToSiteSocketEvents$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(setSelectedSite),
                tap(({ siteID }) => this.uISocketService.setCurrentSite(siteID)),
            ),
        { dispatch: false },
    );
}
